import { Injectable } from '@angular/core';

import { TipoLocalidade } from "./localidade-tipos.model";
import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";

@Injectable()
export class LocalidadeTiposApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: TipoLocalidade, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoLocalidade, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"tipo","where":{"ativo":true}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidades-tipos/localidade-tipos-api.service.ts
 **/